import { Card as PrimeCard } from 'primereact/card'
import styled from 'styled-components'

export const Container = styled.div`
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

export const Filters = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    align-items: center;
`

export const CardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1.5rem;
    padding: 1rem;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 0rem;
    }
`

export const StyledCard = styled(PrimeCard)`
    border: 1px solid #e5e7eb;
    border-radius: 1rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease-in-out;
    cursor: default;
    width: max-content;

    .p-card-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 1rem;
    }

    @media (max-width: 768px) {
        width: 100%;

        .p-card-content {
            gap: 0rem;
        }
    }
`
export const CardText = styled.p`
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    padding: 0;
`
